import { ShimmerThumbnail, ShimmerTitle, ShimmerText } from 'react-shimmer-effects';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../../../app/hooks';
import ChecksTable from './components/ChecksTable/ChecksTable';
import styles from './Checks.module.scss';
import { useEffect, useState } from 'react';
import { getAlerts } from '../../../../../../store/dashboard/AlertEngine/alertEngine_apiHelpers';
import { isEmpty } from 'lodash';
import A4Page from '../../../../../AicaPDFReport/A4Page/A4Page';

export type CriterionRow = {
    criterionResult: string;
    description: string;
    category: string;
    alertDate: string;
};

function Checks({
    isLoading,
    isGeneratingProfile,
    isPDFReport = false,
}: {
    isLoading: boolean;
    isGeneratingProfile: boolean;
    isPDFReport?: boolean;
}) {
    const params = useParams();
    const user = useAppSelector((state) => state.user);

    const [totalRecords, setTotalRecords] = useState(0);
    const [rowData, setRowData] = useState<CriterionRow[]>([]);
    const [filters, setFilters] = useState({
        date: 1,
        severity: 1,
    });

    const showTable = !isEmpty(rowData) || !isGeneratingProfile;

    useEffect(() => {
        if (isEmpty(rowData)) getTableData();
    }, []);

    const getTableData = async () => {
        const payload = {
            assesseOrgId: params?.id ?? '',
            parentOrgId: user?.userData?.investorOrgId,
            alertTypes: ['CRITERIA'],
            pageNumber: 1,
            pageSize: 100, //@todo: as we don't have pagination for checks table we're hardcoding this.
        };
        const res = await getAlerts(payload);
        if (res) {
            setRowData(res.criteria);
            setTotalRecords(res.totalRecords);
        }
    };

    if (isEmpty(rowData)) {
        return <></>;
    }

    const render = (
        <div className={styles.checks} style={{ display: showTable ? '' : 'none' }}>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <h2 className={styles.heading}>Checks</h2>
                </div>
                <div className={styles.headerRight}></div>
            </div>

            <div className={styles.content}>
                <div className={styles.contentBody}>
                    {isLoading ? (
                        <div className={styles.shimmerContainer}>
                            <ShimmerTitle line={1} gap={20} variant="primary" />
                            <ShimmerThumbnail height={78} rounded />
                            <ShimmerText line={12} gap={10} className={styles.shimmerText} />
                        </div>
                    ) : (
                        <ChecksTable assesseOrgId={params?.id ?? ''} parentOrgId={user?.userData?.investorOrgId} rowData={rowData} />
                    )}
                </div>
            </div>
        </div>
    );

    if (isPDFReport) return <></>;
    else return render;
}

export default Checks;
